import { RefreshCw } from 'lucide-react';
import { twJoin } from 'tailwind-merge';

import { Button, useMainFormContext } from '@/_components';
import { usePermissions } from '@/_providers/auth-provider/use-permissions';
import type { UseBooleanCallbacks } from '@/_shared';

import { type THeaderWithBack } from './left-header-with-back';
import { StickyPageHeader } from './sticky-page-header';

import { DeleteButton, EditButton } from '../buttons';

type Props = THeaderWithBack & {
  edit?: [boolean, UseBooleanCallbacks];
  isDeleting?: boolean;
  onDelete?: () => void;
  isViewOnly?: boolean;
};

export function StickyPageHeaderWithEdit({ routes, title, edit, backLink, isDeleting, onDelete, isViewOnly }: Props) {
  const { isFormDirty, isSubmitting } = useMainFormContext();
  const { currentModelPermissions } = usePermissions();

  return (
    <StickyPageHeader title={title} routes={routes} backLink={backLink}>
      <div className={twJoin('justify-start gap-3', isViewOnly ? 'hidden' : 'flex')}>
        {edit?.[0] && (
          <Button
            iconLeft={RefreshCw}
            disabled={!isFormDirty}
            type="submit"
            iconClassName="xs:block hidden"
            showLoader={isSubmitting}
            size="sm"
          >
            Update
          </Button>
        )}
        {edit && currentModelPermissions?.update && <EditButton edit={edit} />}
        {onDelete && currentModelPermissions?.delete && (
          <DeleteButton size="sm" tooltipTitle="" callback={onDelete} isDeleting={isDeleting} confirmDelete />
        )}
      </div>
    </StickyPageHeader>
  );
}
